import { isOpx, getOpxHostApi } from 'owa-opx';

export default function notifyOpxReady() {
    if (isOpx()) {
        getOpxHostApi().then(opxHostApi => opxHostApi.onPageReady());
    }
}
